import React, { useState } from 'react'
// import QRCode from "react-qr-code";
// import { v4 as uuidv4 } from 'uuid';
// import Barcode from "react-barcode";
// import SearchIcon from '@mui/icons-material/Search';
import ScienceIcon from '@mui/icons-material/Science';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

function ProductType({ serverUrl, titleOfPage, user, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();



    const [viewProductPop, setViewProductPop] = useState(false);
    const [productTypeView, setProductTypeView] = useState("Edit");
    const [checkedAll, setCheckedAll] = useState(false);

    const currentProductList = [{
        "RefNo": 6,
        "value": "DD Bio ZX2-10 Year",
        "Sequence": "1",
        "Status": true,
        "Details": "10 Year Warranty",
    },
    {
        "RefNo": 6,
        "value": "DD Cube X2-12 Year",
        "Sequence": "1",
        "Status": true,
        "Details": "12 Year Warranty",
    },
    {
        "RefNo": 6,
        "value": "DD Bio Zw-20 Year",
        "Sequence": "1",
        "Status": true,
        "Details": "20 Year Warranty",
    },
    {
        "RefNo": 6,
        "value": "DD Cube One 15 Year",
        "Sequence": "1",
        "Status": true,
        "Details": "15 Year Warranty",
    }]
    const [productList, setProductList] = useState([
        {
            "RefNo": 6,
            "value": "DD Bio ZX2-10 Year",
            "Sequence": "1",
            "Status": true,
            "Details": "10 Year Warranty",
        },
        {
            "RefNo": 6,
            "value": "DD Cube X2-12 Year",
            "Sequence": "1",
            "Status": true,
            "Details": "12 Year Warranty",
        },
        {
            "RefNo": 6,
            "value": "DD Bio Zw-20 Year",
            "Sequence": "1",
            "Status": true,
            "Details": "20 Year Warranty",
        },
        {
            "RefNo": 6,
            "value": "DD Cube One 15 Year",
            "Sequence": "1",
            "Status": true,
            "Details": "15 Year Warranty",
        }
    ]);

    const [selectedBox, setSelectedBox] = useState([]);


    const handleSelectAll = () => {
        const allButtons = document.querySelectorAll(".barCodeSelector");
        if (checkedAll) {
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = false
            }
            setCheckedAll(false)
            setSelectedBox([])

            // console.log(selectedBox)
        } else {
            let allRest = [];
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = true
                allRest.push(allButtons[i].id)
            }

            setSelectedBox(allRest)
            setCheckedAll(true)

            // console.log(allRest)
        }
    }


    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3 d-flex gap-3 justify-content-between  flex-wrap'>
                        <div className='d-flex gap-5 flex-wrap'>

                        </div>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                <input type="search" placeholder='Search Product' onInput={(e) => { setProductList(currentProductList.filter((product) => { return JSON.stringify(product).includes(e.target.value.toString().trim()) })) }} />
                            </div>
                            <CSVDownloader
                                type={Type.Button}
                                filename={'ProductType'}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                data={
                                    jsonToCSV(productList)
                                }
                            >
                                Export to Excel
                            </CSVDownloader>
                        </div>
                    </div>
                    <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                        <span>
                            Total Records:
                        </span>
                        {
                            productList.length > 0 ?
                                productList.length
                                :
                                "0"
                        }
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center">
                                    <th valign='middle'><input type="checkbox" className='form-check-input' onChange={(e) => { handleSelectAll(); }} /></th>
                                    <th valign='middle'>Value Ref. No.</th>
                                    <th valign='middle'>Product Type Value</th>
                                    <th valign='middle'>Sequence</th>
                                    <th valign='middle'>Status</th>
                                    <th valign='middle'>Details</th>
                                    <th valign='middle'>Unit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    productList.length > 0 ?
                                        productList.map((data, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td valign='middle'>
                                                        <input type="checkbox" className='form-check-input barCodeSelector' />
                                                    </td>
                                                    <td valign='middle'>
                                                        {data['RefNo']}
                                                    </td>
                                                    <td valign='middle'>{data.value}</td>
                                                    <td valign='middle'>{data.Sequence}</td>
                                                    <td valign='middle'>{data.Status ? "true" : "false"}</td>
                                                    <td valign='middle'>{data.Details}</td>
                                                    <td valign='middle'>
                                                        <button className='themeButtons px-3 py-1 rounded w-100' style={{ minWidth: "50px", maxWidth: "100px" }} onClick={() => { setViewProductPop(true); }}>Edit</button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td colSpan={7}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    No Data
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>



            <Modal
                show={viewProductPop}
                onHide={() => { setViewProductPop(false) }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            {
                                productTypeView === "Edit" ?
                                    "Edit Product Type"
                                    :
                                    "New Product"
                            }
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-4 d-flex align-items-center">Type Value</div>
                                        <div className="col-8 d-flex align-items-center">
                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-4 d-flex align-items-center">Sequence</div>
                                        <div className="col-8 d-flex align-items-center">
                                            <input type="number" min={0} className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-4 d-flex align-items-center">Status</div>
                                        <div className="col-8 d-flex align-items-center">
                                            <select name="" id="" className='customFieldForDence' style={{ maxWidth: "300px" }}>
                                                <option value="">Active</option>
                                                <option value="">Inactive</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-4 d-flex align-items-start pt-1">Details</div>
                                        <div className="col-8 d-flex align-items-center">
                                            <textarea name="" id="" className='customFieldForDence' style={{ maxWidth: "300px" }}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        <input type="submit" value="Update" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ProductType